import styled from "styled-components";
import { BaseButton } from "@shared/styles/common.styled";

export const BoxInfo = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-shadow: 2px 2px 4px 1px rgba(0, 76, 127, 0.25);
  background-color: white;
  padding-bottom: 30px;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  padding: 10px;
`;

export const ProductTitle = styled.div`
  justify-self: auto;
  color: #cccccc;
  font-weight: bold !important;
  font-size: 18px;
`;

export const ErrorMessage = styled.div`
  justify-self: auto;
  color: red;
  font-weight: bold !important;
  font-size: 18px;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column ?? "1fr"};
  gap: 1.25rem;
  margin-bottom: 10px;
  font-weight: normal;
  margin-top: 10px;
  padding: 10px;
`;

export const ButtonWrapper = styled.div`
  text-align: right;
`;

export const ButtonData = styled(BaseButton)`
  background: #15aee5;
  border: #15aee5;
  margin-right: 0px;
  font-weight: normal;
  width: auto;
  padding: 8px 14px;
  font-size: 16px;
  font-family: lato;
`;

export const NoDocument = styled.span`
  font-family: Lato;
  font-size: 16px;
  font-style: italic;
  font-weight: 400;
  line-height: 40px;
  letter-spacing: 0px;
  text-align: left;
  color: #cccccc;
`;
